<div class="container">
    <div class="card border-primary p-1 p-md-4">
        <div class="card-body row">
            <div class="col-12 col-md-4 d-block">
                <app-shadow-dom-encapsulate>
                    <svg-icon
                        [svgClass]="'svg-colors'"
                        [src]="'webinar-logo' | cmsImageSrc | async"
                        [svgAriaLabel]="'webinar-logo' | cmsImageAlt | async"
                    ></svg-icon>
                </app-shadow-dom-encapsulate>
            </div>

            <div class="col-12 col-md-8">
                <h4>
                    <span
                        class="d-block mt-3 mt-md-1 d-md-none"
                        [innerHTML]="
                            'interested-individuals-webinar-title'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></span>
                    <span
                        class="hr d-none d-md-inline-block"
                        [innerHTML]="
                            'interested-individuals-webinar-title'
                                | cmsText
                                | jpText
                                | async
                        "
                    ></span
                    ><span
                        class="mt-2 m-md-3 badge bg-primary"
                        [innerHTML]="'webinar-badge' | cmsText | jpText | async"
                    ></span>
                    <hr class="webinar-hr d-md-none" />
                </h4>

                <span
                    [innerHTML]="
                        'interested-individuals-webinar-text'
                            | cmsText
                            | jpText
                            | async
                    "
                ></span>
                <div>
                    <h6
                        [innerHTML]="
                            webinarScheduleTitle | cmsText | jpText | async
                        "
                    ></h6>
                    <span
                        [innerHTML]="
                            webinarScheduleText | cmsText | jpText | async
                        "
                    ></span>
                </div>
                <div class="btn-container-left">
                    <a
                        [routerLink]="'../info/about-webinars'"
                        id="home-about-webinars-button"
                        class="btn btn-outline-primary px-5 text-left"
                    >
                        {{ 'webinars-button-text' | cmsText | async }}
                        <span class="fa fa-chevron-right"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
